<template>
    <div class="product_detail">
        <div class="box" v-if="isReload==false && Object.keys(product_info).length!==0">
            <!-- 商品图片与操作 -->
            <div class="product_operating">
                <!-- 路径导航 -->
                <el-breadcrumb separator-class="el-icon-arrow-right" class="product_operating_nav">
                    <el-breadcrumb-item :to="{ path:'/'}">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{path:'/product_list',query:{product_class_name:product_info.product_class_name,product_top_class_id:product_info.product_top_class_id}}">{{product_info.product_top_class_name}}</el-breadcrumb-item>
                    <el-breadcrumb-item >{{product_info.product_class_name}}</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="box_operation">
                    <!-- 商品图片 -->
                    <div class="show_image">
                        <el-image
                            fit="scale-down"
                            style="width:460px;min-width:460px;height:440px;"
                            :src="bigImage"
                        >
                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                                </div>
                            </div>
                            <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                <div class="el_image">
                                    <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                                </div>
                            </div>
                        </el-image>
                        <ul>
                            <li @click="imageMove(1)" ><i class="iconfont icon-zuokuohao"></i></li>
                            <li>
                                <div id="image_box">
                                    <div v-for="(item,index) in product_info.product_img_url" :key="'A'+index" @click="showImg(item)">
                                        <el-image
                                            fit="scale-down"
                                            style="width:107px;min-width:107px;max-width:107px;height:80px;cursor:pointer;"
                                            :src="item"
                                        >
                                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                                <div class="el_image">
                                                    <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>
                                                </div>
                                            </div>
                                            <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                                <div class="el_image">
                                                    <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                                                </div>
                                            </div>
                                        </el-image>
                                    </div>
                                </div>
                            </li>
                            <li @click="imageMove(2)" ><i class="iconfont icon-youkuohao"></i></li>
                        </ul>
                    </div>
                    <!-- 商品操作 -->
                    <ul class="operation">
                        <li>
                            <h3>{{product_info.product_name}}</h3>
                            <p>{{product_info.product_remark}}</p>
                        </li>
                        <li>
                            <p>
                                零售价：<span>￥<i>{{product_info.unit_price}}</i></span>
                                <span><i>{{product_info.discount==10?'':product_info.discount+'折'}}</i></span>
                            </p>
                            <p>￥<span>{{product_info.product_discount_price}}</span></p>
                        </li>
                        <li>
                            <p></p>
                            <ul v-if="product_info.store_qty>0">
                                <li>数量：<el-input-number v-model="num" :min="1"  ></el-input-number></li>
                                <!-- <li>仅限购买{{10}}件</li> -->
                                <!-- <li>库存：<span>{{product_info.store_qty}}</span>{{product_info.product_unit}}</li> -->
                                <li>库存：<span style="color:red">{{product_info.store_qty_name}}</span></li>
                            </ul>
                            <ul v-else style="padding-top:50px;">
                                <li>预订数量：<el-input-number v-model="num" :min="1"></el-input-number></li>
                                <!-- <li >暂无库存~~</li> -->
                            </ul>
                        </li>
                        <li>
                            <ul v-if="product_info.store_qty>0">
                                <li  @click="add_goods_car">加入购物车</li>
                                <li @click="goSettlement(0)">立即购买</li>
                                <li @click="goSettlement(1)">
                                    预&nbsp;&nbsp;订
                                    <div class="subscript_content">折 扣</div>
                                </li>
                               
                            </ul>
                            <ul v-else>
                                <li @click="goSettlement(1)">
                                    预&nbsp;&nbsp;订
                                    <div class="subscript_content">折 扣</div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 商品详细信息-->
            <div class="product_info" >
                <div><h3>详细信息</h3></div>
                <ul class="img_list" >
                    <li v-for="(item,index) in product_info.product_describe_img" :key="'B'+index" >
                        <el-image
                            lazy
                            fit="cover"
                            style="width:790px;min-width:790px;min-height:100px;"
                            :src="item"
                        >
                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:26px"></span>
                                </div>
                            </div>
                            <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                <div class="el_image">
                                    <el-image  fit="cover" :src="src.src_err"  style="width:200px;height:200px;"></el-image>
                                </div>
                            </div>
                        </el-image>
                    </li>
                    <li  v-for="(item,index) in htmlstr" :key="'C'+index">
                        <el-image
                            lazy
                            fit="cover"
                            style="width:790px;min-width:790px;min-height:100px;"
                            :src="item"
                        >
                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:26px"></span>
                                </div>
                            </div>
                            <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                <div class="el_image">
                                    <el-image  fit="cover" :src="src.src_err"  style="width:200px;height:200px;"></el-image>
                                </div>
                            </div>
                        </el-image>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 数据加载 -->
        <div v-if="isReload"  style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <div v-loading="true"></div>
            <div style="color:#409eff;font-size:14px;margin:100px 0 0 -14px;">数据加载中</div>
        </div>
        <!-- 无数据 -->
        <div v-if="(isReload==false && Object.keys(product_info).length==0) || (( product_info.product_describe_img!==undefined && product_info.product_describe_img.length===0) && (htmlstr!==undefined && htmlstr.length===0))"
            style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <el-image
                fit="cover"
                style="width:600px;height:600px;"
                :src="src.src_null"
            >
                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                    <div class="el_image">
                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                    </div>
                </div>
                <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                    <div class="el_image">
                        <el-image  fit="cover" :src="src.src_err"  style="width:100px;height:100px;"></el-image>
                    </div>
                </div>
            </el-image>
        </div>
    </div>
</template>
<script>
import { setTimeout } from 'timers';
import src_err from '@/assets/img/err.png'
import src_null from '@/assets/img/null.png'

export default {
    name:'product_detail',
    data(){
        return {
            src:{
                src_err,
                src_null
            },
            length:'',
            // 大图
            bigImage:'',
            // 是否加载
            isReload:true,
            // 商品详情
            product_info:{},
            // 商品数量
            num: 1,
            htmlstr:[]
        }
    },
    methods:{
        goSettlement(val){
            if(val==0 && this.num >this.product_info.store_qty){
                this.$message({
                    message:`购买数量超过库存,请重新选择`,
                    type: 'error'
                });
                return
            }
            this.$router.push({path:'/settlement',query:{product_hash:this.product_info.product_hash,qty:this.num,isReserve:val}})
        },
        // 点击查看大图
        showImg(o){
            setTimeout(()=>{
                this.bigImage=o
            },500)
        },
        //加入购物车
        add_goods_car(){
            this.$http({
                url:'add_goods_car',
                data:{
                    type:'increase',
                    product_hash:this.product_info.product_hash,
                    qty:Number(this.num)
                }
            }).then((res)=>{
                if(res.code==1){
                    this.$router.push({
                        path:'/add_goods_car',
                        query:{
                            product_name:this.product_info.product_name,
                            product_imgUrl:this.product_info.product_img_url[0],
                            product_num:this.num
                        }
                    })
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 图片左右点击
        imageMove(o){
            if(o==1){
                let wid=getComputedStyle(document.getElementById("image_box")).width
                wid=wid.substring(0,wid.length-2)-381

                let lef=getComputedStyle(document.getElementById("image_box")).left
                lef=Math.abs(lef.substring(0,lef.length-2)-0)

                if(lef<wid){
                    lef+=127
                }else if(lef>=wid){
                    return
                }
                document.getElementById("image_box").style.left=-lef+'px'
            }else if(o==2){
                let lef=getComputedStyle(document.getElementById("image_box")).left
                lef=lef.substring(0,lef.length-2)-0

                if(lef>=0){
                    return

                }else if(lef<0){
                lef+=127
                }
                document.getElementById("image_box").style.left=lef+'px'
            }
        },
    },
    created(){
        if(this.$route.query.product_hash){
            this.$http({
                url: 'product_detail',
                data: {
                    product_hash:this.$route.query.product_hash
                }
            }).then((res)=>{
                this.isReload=false
                if(res.code==1){
                    this.product_info=res.data.product_info
                    this.length=res.data.product_info.product_img_url.length

                    if(res.data.product_info.product_img_url.length>0){
                        this.bigImage=res.data.product_info.product_img_url[0]
                    }

                    // 处理图片字符串
                    if(res.data.product_info.product_external_img.length>0){
                        let arr=res.data.product_info.product_external_img.match(/src="([^"]*?)"/ig)
                        for(let i in arr){
                            arr[i]=arr[i].replace(/(src=")|(")/ig,'')
                            this.htmlstr=arr
                        }
                    }
                }
            }).catch((err)=>{
                console.log(err)
            })
        }
    },
}
</script>
<style lang="scss" scoped>
// 商品图片与操作
.product_operating{
    width:1200px;
    margin:0 auto;
    padding-bottom:100px;
}
.product_operating_nav{
    padding:40px 0 30px;
}
.box_operation{
    display:flex;
    align-items: flex-start;
    justify-content: space-between;
}
.show_image>ul{
    display:flex;
    align-items: center;
    margin-top:40px;
    width:460px;
    height:80px;
    position:relative;
    li:first-child,li:last-child{
        width:40px;
        height:40px;
        border-radius:50%;
        line-height:40px;
        text-align:center;
        color:#D4D4D4;
        // border:1px solid #D4D4D4;
        cursor:pointer;
        z-index:2;
        opacity:1;
        i{
            font-size:22px;
        }
    }
    li:first-child{
        position:absolute;
        left:0;
        top:20;
    }
    li:last-child{
        position:absolute;
        right:0;
        top:20;
    }
    li:first-child:hover,li:last-child:hover{
        opacity:1;
        animation:hover_in 1s linear 1;
    }
    li:nth-child(2){
        width:380px;
        height:80px;
        margin:0 40px;
        overflow: hidden;
        position:relative;
        z-index:0;
        >div{
            display:flex;
            position:absolute;
            left:0;
            top:0;
            z-index:1;
        }
    }
}
@keyframes hover_in {
    0% {opacity:0;}
    20% {opacity:.8;}
    40% {opacity:.2;}
    60% {opacity:.5;}
    80% {opacity:.9;}
    100% {opacity:1;}
}
.operation{
    width:600px;
}
.operation>li:nth-child(1){
    border-bottom:1px solid rgb(219, 206, 206);
    h3{
        font-weight:500;
        font-size:30px;
        line-height:30px;
    }
    p{
        padding:20px 0;
        line-height:25px;
    }
}
.operation>li:nth-child(2){
    border-bottom:1px solid #D4D4D4;
    p:first-child{
        padding:20px 0 10px;
        span:first-child{
            text-decoration: line-through;
            color:#BABDBF;
            margin-right:100px;
        }
        span:last-child{
            font-size:22px;
            color:#F41200 ;
        }
    }
    p:last-child{
        padding:10px 0 20px;
        font-size:30px;
        color:#F41200 ;
    }
}
.operation>li:nth-child(3){
    p{
        padding:20px 0;
    }
    ul{
        display:flex;
        align-items: center;
        justify-content: space-between;
        padding:20px 0;

        li:nth-child(2),li:last-child{
            color:#BABDBF;
        }
    }
}
.operation>li:nth-child(4){
    ul{
        display:flex;
        align-items: center;
        justify-content: space-around;
        color:white;
        margin-top:60px;
        li{

            width:180px;
            height:50px;
            line-height:50px;
            text-align: center;
            background:#FE9535 ;
            border-radius:5px;
            font-size:18px;
            font-weight:500;
            cursor: pointer;
        }
        li:last-child{
            background:#F41200 ;
            // margin-left:50px;
        }
    }
}
//商品详细信息
.product_info{
    >div{
        background:#F7F7F7 ;
        >h3{
            width:1200px;
            height:70px;
            line-height:70px;
            margin:0 auto;
            font-size:28px;
        }
    }
    .img_list{
        >li{
            display:flex;
            justify-content: center;
            width:1200px;
            margin:0 auto;
            >div{
                width:790px;
                display:flex;
                justify-content: center;
            }
        }
        >li:last-child{
            margin-bottom:40px;
        }
    }
}
//角标设置
.reserve_subscript{
    overflow: hidden;
    position: relative;

    .subscript_content {
        font-size: 14px;
        color: #fff;
        height: 19px;
        width: 66px;
        position: absolute;
        top: 10px;
        right: -15px;
        text-align: center;
        line-height: 19px;
        font-family: "\9ED1\4F53";
        background-color: #FE9535;
        -webkit-transform: rotate(
        45deg
        );
            transform: rotate(
        45deg
        );
    }
}
</style>
<style scoped>
.show_image>ul >>> .el-image{
    display:block;
    margin:0 10px;
}
.operation >>> .el-input-number{
    width:220px;
}
.product_detail{
    box-sizing: border-box;
    padding-top: 46px;
    min-height: 100%;
}
</style>


